import { Component } from '@angular/core';

@Component({
  selector: 'app-organization-common-setting',
  templateUrl: './organization-common-setting.component.html',
})
export class OrganizationCommonSettingComponent {
}
